import React, { Component } from 'react';
import { RootState } from '../../../redux/store';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import AccessContainer from '../../access/AccessContainer';
import { AccessBase } from '../../../domain/access/BaseAccess';
import { changeEvent } from '../../../redux/actions/ChannelActions';
import RoleHelper from '../../../RoleHelper';

class TransactionAccessComponent extends Component<Props> {
  render() {
    const {
      event: { event },
    } = this.props;
    const access: AccessBase = { permission: event.permission, collaborators: event.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('Transaction')} />;
  }

  private changeAccess = (access: AccessBase) => {
    const {
      event: { event },
      changeEvent,
    } = this.props;
    event.permission = access.permission;
    event.collaborators = access.collaborators;
    changeEvent(event);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  event: state.event,
});

const mapDispatchToProps = { changeEvent };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(TransactionAccessComponent);
